import { Progress } from '@chakra-ui/react';
import { FC } from 'react';

import { Tooltip } from '../../../design-system/tooltip';

type MeterProps = {
	matches: number;
	total: number;
};

export const Meter: FC<MeterProps> = ({ matches = 0, total = 0 }) => {
	const value = total === 0 ? 0 : (matches / total) * 100;

	return (
		<Tooltip label={`${matches} / ${total}`} placement="top" hasArrow>
			<Progress
				height={2}
				size="sm"
				value={value}
				styleConfig={{
					baseStyle: {
						track: {
							bgColor: 'bg.canvas',
						},
						filledTrack: {
							bgColor: 'purple.300',
							transition: 'width 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
						},
					},
				}}
			/>
		</Tooltip>
	);
};
